import type { Auth } from 'reducers/auth'

// Thanx admins impersonate the merchant's admin user, so we can't infer their
// role from `is_admin` alone. Both 403 interceptors and the legal-docs guards
// branch on this — keeping the read in one place avoids drift if the auth
// shape ever changes. Lives in its own file (rather than `selectors/auth`)
// to avoid pulling the merchant-selector + ORM cycle into `api/index.ts`.
export function selectIsThanxAdmin(state: { auth?: Auth }): boolean {
  return !!state.auth?.is_thanx_admin
}
